import React from "react";

import { Modal } from "antd";
import { template } from "@reco-m/core";
import { changeUrlParams, ViewComponent } from "@reco-w/core-ui";

import { Namespaces, loginModel } from "@reco-w/auth-models";
import { LoginCommon } from "./login.common";

export namespace JudgeLogin {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {
        isShowModal: boolean;

        onSuccess?: () => void;

        onClose?: () => void;
    }

    export interface IState extends ViewComponent.IState, loginModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.login;

        /**
         * 渲染登录
         * @returns
         */
        renderLogin() {
            const { isShowModal, onSuccess, onClose } = this.props;
            return (
                <Modal wrapClassName={"login-layout"} footer={null} visible={isShowModal} centered={true} width="430px" onCancel={() => onClose && onClose()}>
                    <div className="login-mini">
                        {this.renderEmbeddedView(LoginCommon.Page as any, {
                            isModal: true,
                            onSuccess: () => {
                                const isLogin = this.getSearchParam("isLogin");

                                this.goTo(changeUrlParams(window.location.search, { isLogin: isLogin ? null : true }));
                                onSuccess && onSuccess();
                            },
                        })}
                    </div>
                </Modal>
            );
        }

        render(): React.ReactNode {
            return this.renderLogin();
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.login]);
}
